export const COURSE_THEME_DEFAULT_THEME_COLOR = '#094967';
export const COURSE_THEME_DEFAULT_BACKGROUND_COLOR = '#ECF0F1';
export const COURSE_THEME_DEFAULT_BACKGROUND_IMAGE = '';
export const COURSE_THEME_DEFAULT_BACKGROUND_IMAGE_REPEAT = 'no-repeat';
